export enum GroupSetting {
    Doctors = 1,
    Pharmacists = 2,
}
